import script from "./comOffline.vue?vue&type=script&setup=true&lang=js"
export * from "./comOffline.vue?vue&type=script&setup=true&lang=js"

import "./comOffline.vue?vue&type=style&index=0&id=2e7a882f&lang=less"

const __exports__ = script;

export default __exports__